import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { about, allInOne, barkodOxuyucu, barkodPrinter, barkodProcessor, cardReader, carousel2, dataTerminal, hero, pulQutulari, blogs1, blogs2, blogs3, project1, project2, project3, project4, project5, project6, rightArrow, service1, service2, service3, service4, rightUp } from '../../assets/index';
import { useTranslation } from 'react-i18next';
import HeaderOther from '../../Components/HeaderOther/HeaderOther';
import Title from '../../Components/Title/Title';


const About = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);
  return (
   <>
   <HeaderOther/>
   <Title title="Haqqımızda"/>
   <div className='max-w-containerSm md:max-w-container mx-auto pt-[94px] md:pt-[124px]'>
   <div className='rounded-[40px]'>
    <div className='max-w-containerSm md:max-w-container mx-auto mt-[44px] md:mt-[80px] py-[80px]'>
    <p className='text-[24px] md:text-[40px] font-bold md:font-semibold mb-10 font-barlow'>Rahatlıq və Səmərəliliyin Birləşdiyi <span className='font-barlow text-[#E11E26]'>Mərkəz</span></p>
    <div className='md:flex gap-8'>
        <div className='md:w-[650px]'>
        <img className='rounded-[20px]' src={about}></img>
        </div>
        <div className='md:w-[657px] flex flex-col justify-center mt-5 md:mt-0'>
            <p className='md:mb-6 mb-4 font-semibold text-[20px] md:text-[24px]'>İş Dünyasında Fərq Yaradan Məkan; <span className= 'text-[#E11E26] font-semibold'>AF HOLDINQ</span></p>
            <p className='md:mb-16 mb-9'>İş mərkəzimiz müasir ofis sahələri, premium xidmətlər və geniş imkanlarla fərq yaradır. Burada sizə rahatlıq, prestij və səmərəliliyi bir arada təqdim edirik. Gözəllik salonu, fitness mərkəzi, hovuz və geniş parking kimi xidmətlərlə işinizə tam fokuslanma imkanı əldə edirsiniz. Biznesinizin hər addımında uğurunuza dəstək olmaq üçün ən ideal şəraiti təmin edirik. Burada fərqi hiss edin, iş dünyasında bir addım öndə olun.İş mərkəzimiz müasir ofis sahələri, premium xidmətlər və geniş imkanlarla fərq yaradır. Burada sizə rahatlıq, prestij və səmərəliliyi bir arada təqdim edirik. Gözəllik salonu, fitness mərkəzi, hovuz və geniş parking kimi xidmətlərlə işinizə tam fokuslanma imkanı əldə edirsiniz. Biznesinizin hər addımında uğurunuza dəstək olmaq üçün ən ideal şəraiti təmin edirik. Burada fərqi hiss edin, iş dünyasında bir addım öndə olun.</p>

        </div>
    </div>
   </div>
   </div>
   </div>  </>
  );
};
 
export default About; 